import styled from 'styled-components';
import { StyledToggletipTriggerProps } from './types';
import { focusRing } from '@redsift/design-system';

/**
 * Component style.
 */
export const StyledToggletipTrigger = styled.button<StyledToggletipTriggerProps>`
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  color: inherit;
  text-decoration: inherit;
  cursor: default;
  display: inline-flex;

  ${focusRing}
`;
